function showSurvey()
{   
  document.getElementById("cross").style.display = "none";//hide fixation cross if any
  showTrialInfo();//only displays if selected
  showTimer();

  //show only the necessary number of rows
  for (iRows=0; iRows<document.getElementById('tableSurvey').rows.length; iRows++)
    {
      if (iRows < listNoStim[trialRow]){$(document.getElementById("tableSurvey").rows[iRows]).show();}
      else{$(document.getElementById("tableSurvey").rows[iRows]).hide();}    
    }

  // if (listArrays[allColumns.indexOf('target')][trialRow] == "na"){$(document.getElementById("tableSurvey").caption).hide();}
  //   else {$(document.getElementById("tableSurvey").caption).show();}

  document.getElementById("surveyQuestion").innerHTML = listArrays[allColumns.indexOf('target')][trialRow];
  // document.getElementById("tableSurvey").caption.innerHTML = listArrays[allColumns.indexOf('target')][trialRow];
  document.getElementById("tableSurvey").rows[0].cells[0].innerHTML = listArrays[allColumns.indexOf('stim1')][trialRow];
  document.getElementById("tableSurvey").rows[1].cells[0].innerHTML = listArrays[allColumns.indexOf('stim2')][trialRow];
  document.getElementById("tableSurvey").rows[2].cells[0].innerHTML = listArrays[allColumns.indexOf('stim3')][trialRow];
  document.getElementById("tableSurvey").rows[3].cells[0].innerHTML = listArrays[allColumns.indexOf('stim4')][trialRow];
  document.getElementById("tableSurvey").rows[4].cells[0].innerHTML = listArrays[allColumns.indexOf('stim5')][trialRow];
  document.getElementById("tableSurvey").rows[5].cells[0].innerHTML = listArrays[allColumns.indexOf('stim6')][trialRow];
  document.getElementById("tableSurvey").rows[6].cells[0].innerHTML = listArrays[allColumns.indexOf('stim7')][trialRow];
  document.getElementById("tableSurvey").rows[7].cells[0].innerHTML = listArrays[allColumns.indexOf('stim8')][trialRow];
  document.getElementById("tableSurvey").rows[8].cells[0].innerHTML = listArrays[allColumns.indexOf('stim9')][trialRow];
  document.getElementById("tableSurvey").rows[9].cells[0].innerHTML = listArrays[allColumns.indexOf('stim10')][trialRow];
  document.getElementById("tableSurvey").rows[10].cells[0].innerHTML = listArrays[allColumns.indexOf('stim11')][trialRow];
  document.getElementById("tableSurvey").rows[11].cells[0].innerHTML = listArrays[allColumns.indexOf('stim12')][trialRow];

  document.getElementById("divSurvey").style.display="block";
  recordKeys = 1;
  showButtons();
      /// RESPONSE WINDOW
      if (!isNaN(listArrays[allColumns.indexOf('responseWindow')][trialRow]))
      {
        eventTimeOutResponse = setTimeout("click99()",Number(listArrays[allColumns.indexOf('responseWindow')][trialRow]));
      }
}